"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const classnames_1 = __importDefault(require("classnames"));
const react_json_tree_1 = __importDefault(require("react-json-tree"));
const SelectMenu_1 = __importDefault(require("./SelectMenu"));
const FormControls_1 = __importDefault(require("./FormControls"));
const FormOptions_1 = __importDefault(require("./FormOptions"));
const parser_1 = require("../parser");
const icons_1 = require("../icons");
const __utils_1 = __importDefault(require("../styles/_.utils"));
const RenderFormData_1 = __importDefault(require("../styles/RenderFormData"));
exports.default = (0, mobx_react_1.observer)(({ store, handlers }) => (react_1.default.createElement("div", null,
    react_1.default.createElement("h4", { className: (0, classnames_1.default)(RenderFormData_1.default.heading, __utils_1.default.clearfix) },
        react_1.default.createElement("div", { className: __utils_1.default.left },
            react_1.default.createElement(icons_1.FaTh, { className: RenderFormData_1.default.icon }),
            " Form"),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(__utils_1.default.rigth, RenderFormData_1.default.select) },
            react_1.default.createElement(SelectMenu_1.default, { store: store, handlers: handlers }))),
    react_1.default.createElement(FormControls_1.default, { handlers: handlers, store: store }),
    store.showOptions
        && react_1.default.createElement(FormOptions_1.default, { form: store.formOptions }),
    react_1.default.createElement("br", null),
    react_1.default.createElement(react_json_tree_1.default, { className: __utils_1.default.hidden, hideRoot: true, data: (0, parser_1.parseFormData)(store.selected.form), theme: store.theme, invertTheme: false }),
    react_1.default.createElement("h4", { className: (0, classnames_1.default)(RenderFormData_1.default.heading) },
        react_1.default.createElement(icons_1.FaBars, { className: RenderFormData_1.default.icon }),
        " Fields"),
    react_1.default.createElement("div", { className: (0, classnames_1.default)(RenderFormData_1.default.container) },
        react_1.default.createElement(react_json_tree_1.default, { hideRoot: true, data: (0, parser_1.parseFieldsData)(store.selected.form.fields), theme: store.theme, invertTheme: false })))));
